import type { SortDirectionType } from '@rio-cloud/rio-uikit/utils/SortUtils';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import type { State } from '../../../reducers';
import type { TableColumn } from '../../enums/TableColumn';
import { getTableViewMode, tableSettingsActions } from '../../realtime/header/tablesettings/redux/tablesettings.redux';
import { getIsStateChangesDisplayed } from '../../realtime/redux/realtime.redux';
import { getCurrentColumns } from '../drivingtimes/columnService';
import { getEnhancedSortByAndDir } from '../sorting/sortingService';
import { getSortableStateChangeColumns } from '../statechanges/stateChangesColumnService';
import { TableCardsSortingHeader } from './TableCardsSortingHeader';
import type { TableCardsSortingHeaderDispatchProps, TableCardsSortingHeaderStateProps } from './types';

const mapStateToProps = (state: State): TableCardsSortingHeaderStateProps => {
    const columns = getIsStateChangesDisplayed(state) ? getSortableStateChangeColumns() : getCurrentColumns(state);
    const { sortDir, sortBy } = getEnhancedSortByAndDir(state);
    return {
        columns,
        sortBy,
        sortDir,
        viewType: getTableViewMode(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch): TableCardsSortingHeaderDispatchProps => ({
    onSortChange: (sortBy: TableColumn, sortDir: SortDirectionType): void => {
        dispatch(tableSettingsActions.setSortBy(sortBy));
        dispatch(tableSettingsActions.setSortDir(sortDir));
    },
});

export const TableCardsSortingHeaderContainer = connect(mapStateToProps, mapDispatchToProps)(TableCardsSortingHeader);
